var windowWidth, lazyLink, lazyImages, lazyBackground, lazyIframe, lazyScripts, navigator_platform, lazyLoadedJS, s, i, j, flag;
function init() {
  1 == flag && ((flag = 0), lazyLoadImg(), load_all_js(), lazyLoadBackground(), lazyLoadIframe());
}
function isElementInViewport(e) {
  "function" == typeof jQuery && e instanceof jQuery && (e = e[0]);
  var t = e.getBoundingClientRect();
  return t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth);
}
function lazyLoadLink() {
  lazyLink.forEach(function (e) {
    e.href = null == e.dataset.href ? e.href : e.dataset.href;
  });
}
function lazyLoadImg() {
  lazyImages.forEach(function (e) {
    (e.src = windowWidth < 600 ? (null == e.dataset.mobsrc ? e.dataset.src : e.dataset.mobsrc) : e.dataset.src), e.classList.remove("lazyImage");
  });
}
function lazyLoadBackground() {
  lazyBackground.forEach(function (e) {
    (e.style = windowWidth < 600 ? (null == e.dataset.mobstyle ? e.dataset.style : e.dataset.mobstyle) : e.dataset.style), e.classList.remove("lazyBackground");
  });
}
function lazyLoadIframe() {
  document.getElementsByTagName("html")[0].classList.add("lazy_js"),
    lazyIframe.forEach(function (e) {
      e.src = null == e.dataset.src ? e.src : e.dataset.src;
    });
}
function lazyLoadScripts() {
  j != lazyScripts.length &&
    ("lazyScript" == lazyScripts[j].getAttribute("type")
      ? (lazyScripts[j].setAttribute("type", "lazyloaded"),
        void 0 !== lazyScripts[j].dataset.src
          ? (((s = document.createElement("script")).src = lazyScripts[j].dataset.src),
            document.body.appendChild(s),
            (s.onload = function () {
              j++, lazyLoadScripts();
            }))
          : (((s = document.createElement("script")).innerHTML = lazyScripts[j].innerHTML), document.body.appendChild(s), j++, lazyLoadScripts()))
      : (j++, lazyLoadScripts()));
}
function lazyLoadCss(e) {
  ((s = document.createElement("link")).rel = "stylesheet"), (s.href = e), document.getElementsByTagName("head")[0].appendChild(s);
}
function lazyLoadJS(e) {
  lazyLoadedJS &&
    (setTimeout(function () {
      lazyLoadJS(e);
    }, 200),
    (lazyLoadedJS = 0)),
    (lazyLoadedJS = 1),
    ((s = document.createElement("script")).src = e),
    (s.onload = function () {
      lazyLoadedJS = 0;
    }),
    document.body.appendChild(s);
}
function load_all_js() {
  setTimeout(function () {
    var e = new Event("opt_load");
    window.dispatchEvent(e);
  }, 200),
    lazyLoadCss("https://cdn.judge.me/shopify_v2.css?v=" + Date.now()),
    lazyLoadJS("https://cdn.shopify.com/shopifycloud/shopify/assets/storefront/load_feature-d8a6f1446d67009c524ed4e68648800ba9082eb75548ee28e1050331cbe7ba28.js"),
    lazyLoadJS("https://cdn.shopify.com/shopifycloud/shopify/assets/shopify_pay/storefront-b61f50798075db890698930c4405673937fe89353f7fea7be88b5ce16a9c0af8.js?v=" + Date.now()),
    lazyLoadJS("https://cdn.shopify.com/shopifycloud/shopify/assets/storefront/features-87e8399988880142f2c62771b9d8f2ff6c290b3ff745dd426eb0dfe0db9d1dae.js"),
    lazyLoadJS("https://cdn.shopify.com/shopifycloud/shopify/assets/shop_events_listener-619dded2976e732c6d885de654a8af094bc28e3148dfe9ab8b320781402596b6.js"),
    lazyLoadJS("https://cdn.shopify.com/shopifycloud/consent-tracking-api/v0.1/consent-tracking-api.js"),
    lazyLoadJS("https://cdn.shopify.com/shopifycloud/boomerang/shopify-boomerang-1.0.0.min.js"),
    
    (j = 0),
    (lazyScripts = document.getElementsByTagName("script")),
    lazyLoadScripts(),
    setInterval(function () {
      (lazyImages = document.querySelectorAll("img.lazyImage")), (lazyBackground = document.querySelectorAll(".lazyBackground")), lazyLoadImg(), lazyLoadBackground();
    }, 3e3),
    setTimeout(function() {
      !(function (e, t, n) {
        function a() {
          var e = t.getElementsByTagName("script")[0],
            n = t.createElement("script");
          (n.type = "text/javascript"), (n.async = !0), (n.src = "https://beacon-v2.helpscout.net"), e.parentNode.insertBefore(n, e);
        }
        if (
          ((e.Beacon = n = function (t, n, a) {
            e.Beacon.readyQueue.push({ method: t, options: n, data: a });
          }),
          (n.readyQueue = []),
          "complete" === t.readyState)
        )
          return a();
        e.attachEvent ? e.attachEvent("onload", a) : e.addEventListener("load", a, !1);
      })(window, document, window.Beacon || function () {});
      window.Beacon('init', '586471d1-0733-4ba9-8f86-0ab911672c8a');
    }, 500);
}
document.addEventListener("DOMContentLoaded", function () {
  (windowWidth = screen.width),
    (lazyLink = document.querySelectorAll("link")),
    (lazyImages = document.querySelectorAll("img.lazyImage")),
    (lazyBackground = document.querySelectorAll(".lazyBackground")),
    (navigator_platform = navigator.platform),
    (lazyIframe = document.querySelectorAll("iframe")),
    (lazyScripts = document.getElementsByTagName("script")),
    (i = 0),
    (j = 0),
    (flag = 1),
    "Linux x86_64" != navigator_platform && init(),
    window.addEventListener("scroll", function () {
      init();
    }),
    window.addEventListener("mousemove", function () {
      init();
    }),
    window.addEventListener("click", function () {
      init();
    }),
    window.addEventListener("touchstart", function () {
      init();
    }),
    setTimeout(function () {
      init();
    }, 9999);
});
